import Layouts from "./Layouts";
import { useTypedSelector } from "@lib/redux";
import { getRouteConfig } from "@app/.core/AppMenuRoutes";
import { NavStyle } from "@lib/constants/AppEnums";
import { memo, ReactNode } from "react";
import _ from "lodash";
import { AppLayoutProps } from "./Layouts";

type AppLayoutComponentProps = {
  children?: ReactNode;
  menuProps?: import("./Admin/AdminSidebar").AdminSidebarMenuProps;
  overrideLayout?: NavStyle;
};

const AppLayout: React.FC<AppLayoutComponentProps> = ({
  children,
  menuProps,
  overrideLayout,
}) => {
  const { user, isAuthenticated } = useTypedSelector((state) => state.auth);

  const Layout = isAuthenticated
    ? Layouts[overrideLayout || NavStyle.ADMIN]
    : Layouts[overrideLayout || NavStyle.NON_AUTH];
  const routesConfig = getRouteConfig(user);

  if (!Layout) {
    return null;
  }

  const layoutProps: AppLayoutProps = {
    children: children as any,
    routesConfig,
    menuProps,
  };

  return <Layout {...layoutProps} />;
};

export { Layouts };
export default memo(AppLayout, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});
